import {config} from '../appContext';
import {
    packageVersionAsVer,
    withCacheBust,
    type ICacheBustTokens,
} from './cacheBustQuery';

export type {ICacheBustTokens};

/** eAdm BUILD_VERSION / BUILD_DATE as cache-bust tokens. */
export function eAdmCacheBustTokens(): ICacheBustTokens {
    const parsed = Date.parse(config.BUILD_DATE);
    return {
        ver: packageVersionAsVer(config.BUILD_VERSION),
        t: String(Number.isFinite(parsed) ? parsed : Date.now()),
    };
}

/** Appends eAdm ver/t cache-bust params when the URL does not already include `ver`. */
export function withStaticAssetCacheBust(url: string): string {
    const {ver, t} = eAdmCacheBustTokens();
    return withCacheBust(url, ver, t);
}
